<section id="content" *ngIf="this.lang">
  <div class="page page-profile">

    <!-- page header -->
    <div class="pageheader">
      <h2>{{ lang.problem_solving }} {{ lang.view }}</h2>
      <div class="page-bar">
        <ul class="page-breadcrumb">
          <li>
            <a [routerLink]="'/'+AppFrontRoutes.DASHBOARD"><i class="fa fa-home"></i>
              {{AppSettings.SITE_TITLE | titlecase}}</a>
          </li>
          <li>
            <a [routerLink]="'/'+AppFrontRoutes.PROBLEM_SOLVING">{{ lang.problem_solving }} {{ lang.view }}</a>
          </li>
          <li>
            <span *ngIf="course">{{ course.code }}</span>
          </li>

        </ul>

        <div style="float: right;">
          <div class="social-icons">
            <a class="plus-vdead" (click)="viewProblemSolving()"
              [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
              <i class="fa fa-list"></i>
            </a>
          </div>
        </div>

      </div>
    </div>
    <!-- page content -->
    <div class="pagecontent">

      <!-- row -->
      <div class="row">
        <div class="col-md-12">
          <div class="col-sm-5">
            <div class="panel panel-default">
              <form [formGroup]="generalsForm" class="form-validation" (ngSubmit)="onSubmit()">
                <div class="panel-heading">{{ lang.problemDetails }}</div>
                <div class="panel-body" style="padding: 0px;">



                  <div class="form-group col-sm-12">
                    <div class="form-group col-sm-6">
                      <label>{{ lang.code }}</label>
                      <input type="text" class="form-control" formControlName="code"
                        [ngClass]="formErrorClass(generalsForm.controls.code, generalsFormSubmitted)" disabled>
                    </div>

                    <div class="form-group col-sm-6">
                      <label>{{ lang.code }}</label>
                      <select class="form-control" formControlName="type"
                        [ngClass]="formErrorClass(generalsForm.controls.type, generalsFormSubmitted)" disabled>
                        <option [ngValue]="">Please select</option>
                        <option *ngFor="let type of typeConfig" [ngValue]="type.value">{{type.text}}</option>
                      </select>

                    </div>
                  </div>


                  <div class="form-group col-sm-12">
                    <label>{{ lang.input }}</label>
                    <input type="text" class="form-control" formControlName="input"
                      [ngClass]="formErrorClass(generalsForm.controls.input, generalsFormSubmitted)" disabled>
                  </div>

                  <div class="form-group col-sm-12">
                    <label>{{ lang.class }}</label>
                    <input type="text" class="form-control" formControlName="class"
                      [ngClass]="formErrorClass(generalsForm.controls.class, generalsFormSubmitted)" disabled>
                  </div>


                  <div class="form-group col-sm-12">
                    <label>{{ lang.itemno }}</label>
                    <input type="text" class="form-control" formControlName="item_no"
                      [ngClass]="formErrorClass(generalsForm.controls.item_no, generalsFormSubmitted)" disabled>
                  </div>



                  <div class="form-group col-sm-12">
                    <label>{{ lang.jobno }}</label>
                    <input type="text" class="form-control" formControlName="job_no"
                      [ngClass]="formErrorClass(generalsForm.controls.job_no, generalsFormSubmitted)" disabled>
                  </div>



                  <div class="form-group col-sm-12">
                    <label>{{ lang.other }}</label>
                    <input type="text" class="form-control" formControlName="other"
                      [ngClass]="formErrorClass(generalsForm.controls.other, generalsFormSubmitted)" disabled>
                  </div>


                  <div class="form-group col-sm-12">
                    <label>{{ lang.descriptionoftheproblem }}</label>

                    <textarea class="form-control" formControlName="desp"
                      [ngClass]="formErrorClass(generalsForm.controls.desp, generalsFormSubmitted)" disabled></textarea>
                  </div>


                  <!-- <div class="form-group col-sm-12"> -->
                    <div class="form-group col-sm-6">
                      <label>{{ lang.openingDate }}</label>
                      <input type="text" class="form-control" formControlName="start_date"
                        [ngClass]="formErrorClass(generalsForm.controls.start_date, generalsFormSubmitted)" disabled>
                    </div>

                    <div class="form-group col-sm-6">
                      <label>{{ lang.tobeclosedby }}</label>
                      <input type="text" class="form-control" formControlName="closed_by"
                        [ngClass]="formErrorClass(generalsForm.controls.closed_by, generalsFormSubmitted)" disabled>

                    </div>
                  <!-- </div> -->


                  <div class="form-group col-sm-12">
                    <label>{{ lang.responsible }}</label>
                    <input type="text" class="form-control" formControlName="employee"
                      [ngClass]="formErrorClass(generalsForm.controls.employee, generalsFormSubmitted)" disabled>
                  </div>

                  <div class="form-group col-sm-12" formArrayName="attachments">
                    <label>{{ lang.attachments }}</label>

                    <div class="form-group row" *ngFor="let image of attachments().controls; let i=index">
                      <div class="col-sm-11">
                        <input type="hidden" class="form-control" formControlName="{{i}}">
                        <input type="hidden" class="filestyle" data-buttonText="Choose file"
                          (change)="selectAttachment($event,i)" value="{{image.value.split('/').pop()}}">

                        <a href="http://vmi313621.contaboserver.net/Software_backend/uploads/problem_solving/{{image.value.split('/').pop()}}"
                          target="_blank">{{image.value.split('/').pop()}}</a>

                      </div>

                    </div>
                  </div>

                </div>


              </form>
            </div>

          </div>


          <div class="col-sm-7 zindexset">
            <div class="tabbable">

              <ul class="nav nav-tabs tabs-dark" role="tablist">
                <li role="presentation" [ngClass]="selectedTab == 'treatment' ? 'active' : 'none'"><a href="#treatment" aria-controls="treatment" role="tab" data-toggle="tab">{{ lang.treatment}} 
                  
                  <i *ngIf="treatment_settings.button1" class="fa fa-info-circle" aria-hidden="true"></i>
                  <i *ngIf="treatment_settings.save_t" class="fa fa-check-circle" aria-hidden="true"></i>
                </a></li>

                <li role="presentation" [ngClass]="selectedTab == 'cause' ? 'active' : 'none'"><a href="{{ cause_analysis }}" aria-controls="cause_analysis" role="tab"
                    data-toggle="tab">{{ lang.causeanalysis }}
                    <i *ngIf="cause_settings.button2" class="fa fa-info-circle" aria-hidden="true"></i>
                    <i *ngIf="cause_settings.save_t1" class="fa fa-check-circle" aria-hidden="true"></i>                  
                  </a></li>


                <li role="presentation" [ngClass]="selectedTab == 'corrective' ? 'active' : 'none'"><a href="{{ corrective_actions }}" aria-controls="corrective_actions" role="tab"
                    data-toggle="tab">{{ lang.correctiveActions }}
                    <i *ngIf="corrective_settings.button3" class="fa fa-info-circle" aria-hidden="true"></i>
                    <i *ngIf="corrective_settings.save_t2" class="fa fa-check-circle" aria-hidden="true"></i>                    
                  </a></li>

                <li role="presentation" [ngClass]="selectedTab == 'check' ? 'active' : 'none'"><a href="{{ check_effectiveness }}" aria-controls="check_effectiveness" role="tab"
                    data-toggle="tab">{{ lang.checkEffectiveness }}
                    <i *ngIf="check_settings.button4" class="fa fa-info-circle" aria-hidden="true"></i>
                    <i *ngIf="check_settings.save_t3" class="fa fa-check-circle" aria-hidden="true"></i>                  
                  </a>
                </li>


                <li role="presentation"><a href="#report" aria-controls="report" role="tab" data-toggle="tab">{{ lang.report }}</a>
                </li>


              </ul>

              <div class="tab-content floating-data">
  <div class="tab-pane in" [ngClass]="selectedTab == 'treatment' ? 'active' : 'none'" id="treatment">

                  <div class="panel panel-default">
                    <form [formGroup]="treatmentForm" class="form-validation" (ngSubmit)="onSubmit()">
                      <div class="panel-body ">
                        <div class="form-group col-sm-12">
                          <label class="col-sm-2 control-label" for="form-field-2">
                            <!-- Treatment Implemented --> {{ lang.treatmentImplemented }}
                          </label>
                          <div class="col-sm-10">
                            <textarea class="form-control" formControlName="desp"
                              [ngClass]="formErrorClass(treatmentForm.controls.desp, treatmentFormSubmitted)" [readonly]="treatment_settings.readonly"></textarea>

                              <ng-template [ngTemplateOutlet]="ErrorMsg" [ngTemplateOutletContext]="{msg:treatmentFormErrorMsg.desp, value:treatmentForm.controls.desp, submitted:treatmentFormSubmitted }"></ng-template>


                          </div>
                        </div>

                        <input type="hidden" name="problem_id" value="">
                        <input type="hidden"  name="treatment_id" value="">


                        <div class="form-group col-sm-12">
                          <label class="col-sm-2 control-label" for="form-field-1">
                            <!-- Figures involved --> {{ lang.figuresInvolved }}
                          </label>

                          <div class="col-sm-10 bcb">

                            <input type="hidden" name="empList" value="667" id="empList">

                            <input type="hidden" name="ajaxValues" value="" id="ajaxValues">


                            <div class="col-sm-6" formArrayName="treatmentEmpBlck1">
                              <label>{{ lang.internalReference }}</label>
                              <div class="form-group row"
                                *ngFor="let eref of treatmentEmpBlck1().controls; let i=index">
                                <div class="col-sm-8">
                    

       <select class="form-control"  formControlName="{{i}}" [ngClass]="formErrorClass(treatmentEmpBlck1().controls[i], treatmentFormSubmitted)" style="width: 140%;" [attr.disabled]="treatment_settings.butDis ? '' : null">
                                    <option value="">{{ lang.selectEmployee }}</option>
                                    <option *ngFor="let type of emp_list" [ngValue]="type.item_id">{{type.item_name}}
                                    </option>
                                  </select>

                                  <ng-template [ngTemplateOutlet]="ErrorMsg"
                                  [ngTemplateOutletContext]="{msg:treatmentFormErrorMsg.treatmentEmpBlck1, value:treatmentForm.controls.treatmentEmpBlck1, submitted:treatmentFormSubmitted }">
                                </ng-template>


                                </div>
                                <div class="col-sm-4" style="padding: 0%;">
                                  <!-- <button class="btn btn-primary pull-right" type="button" (click)="addEmployees()"
                                    *ngIf="i==0" [attr.disabled]="treatment_settings.butDis ? '' : null">
                                    <i class="fa fa-plus"></i>
                                  </button>

                                  <button class="btn btn-primary pull-right" type="button" (click)="removeEmail1(i+1)"
                                    *ngIf=" i!=(treatmentEmpBlck1().controls.length-1) " [attr.disabled]="treatment_settings.butDis ? '' : null">
                                    <i class="fa fa-trash-o"></i>
                                  </button> -->

                                  <button class="btn btn-primary pull-right" type="button" (click)="addEmployees()"
                                  *ngIf=" i==(treatmentEmpBlck1().controls.length-1) "  [attr.disabled]="treatment_settings.butDis ? '' : null">
                                  <i class="fa fa-plus"></i>
                                </button>

                                <button class="btn btn-primary pull-right" type="button" (click)="removeEmail1(i)"
                                  *ngIf=" i!=(treatmentEmpBlck1().controls.length-1) "  [attr.disabled]="treatment_settings.butDis ? '' : null">
                                  <i class="fa fa-trash-o"></i>
                                </button>

                                </div>
                              </div>
                            </div>


                            <div class="col-sm-6" formArrayName="externalReferences">
                                <label>{{ lang.externalReference }}</label>
                                <div class="form-group row" *ngFor="let email of externalReferences().controls; let i=index">
                                  <div class="col-sm-8">
                                    <input type="text" class="form-control" formControlName="{{i}}"
                                      [ngClass]="formErrorClass(externalReferences().controls[i], treatmentFormSubmitted)"
                                      style="width: 140%;" [readonly]="treatment_settings.readonly">
                      
                                    <ng-template [ngTemplateOutlet]="ErrorMsg"
                                      [ngTemplateOutletContext]="{msg:treatmentFormErrorMsg.externalReferences, value:externalReferences().controls[i], submitted:treatmentFormSubmitted }">
                                    </ng-template>
                      
                                  </div>
                                  <div class="col-sm-4" style="padding: 0%;">
                                    <button class="btn btn-primary pull-right" type="button" (click)="removeEmail(i)"
                                      *ngIf=" i!=(externalReferences().controls.length-1) " [attr.disabled]="treatment_settings.butDis ? '' : null">
                                      <i class="fa fa-trash-o"></i>
                                    </button>
                                    <button class="btn btn-primary pull-right" type="button" (click)="addEmail()"
                                      *ngIf=" i==(externalReferences().controls.length-1) " [attr.disabled]="treatment_settings.butDis ? '' : null">
                                      <i class="fa fa-plus"></i>
                                    </button>
                                  </div>
                                </div>
                            </div>



                          </div>
                        </div>


                        <div class="form-group col-sm-12">
                          <label class="col-sm-2 control-label" for="form-field-1">
                            <!-- Date --> {{ lang.date }}
                          </label>
                          <div class="col-sm-9">
                            <input type="date" class="form-control" formControlName="date_treatment"
                              [ngClass]="formErrorClass(treatmentForm.controls.date_treatment, treatmentFormSubmitted)" [readonly]="treatment_settings.readonly">

                              <ng-template [ngTemplateOutlet]="ErrorMsg"
                              [ngTemplateOutletContext]="{msg:treatmentFormErrorMsg.date_treatment, value:treatmentForm.controls.date_treatment, submitted:treatmentFormSubmitted }">
                            </ng-template>


                          </div>
                        </div><br><br><br><br><br><br><br>

                        <div class="form-group col-sm-12">
                          <label class="col-sm-2 control-label">{{ lang.cost }}</label>
                          <div class="col-sm-9">
                            <input type="text" class="form-control" formControlName="cost"
                              [ngClass]="formErrorClass(treatmentForm.controls.cost, treatmentFormSubmitted)" [readonly]="treatment_settings.readonly">

                              <ng-template [ngTemplateOutlet]="ErrorMsg"
                              [ngTemplateOutletContext]="{msg:treatmentFormErrorMsg.cost, value:treatmentForm.controls.cost, submitted:treatmentFormSubmitted }">
                            </ng-template>



                          </div>
                        </div>


                        <div class="col-sm-12" formArrayName="service_attach_exists">
                          <div class="form-group col-sm-12">
                            <label>{{ lang.attachments }}</label>
                            <div class="form-group row"
                              *ngFor="let link of service_attach_exists().controls; let i = index;" [formGroupName]="i">
                              <div class="col-sm-11">
                                <input type="file" class="filestyle" data-buttonText="Choose file"
                                  (change)="selectAttachment1($event,i)" formControlName="link" [attr.disabled]="treatment_settings.butDis ? '' : null" appFileDesign>


                              </div>
                              <div class="col-sm-1">
                                <button class="btn btn-primary pull-right" type="button" (click)="removeAttachment(i)"
                                  *ngIf=" i!=(service_attach_exists().controls.length-1) " [attr.disabled]="treatment_settings.butDis ? '' : null">
                                  <i class="fa fa-trash-o"></i>
                                </button>
                                <button class="btn btn-primary pull-right" type="button" (click)="addAttachment()"
                                  *ngIf=" i==(service_attach_exists().controls.length-1) " [attr.disabled]="treatment_settings.butDis ? '' : null">
                                  <i class="fa fa-plus"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>


                        <div class="col-sm-12" formArrayName="service_attach_uploaded">
                          <div class="form-group col-sm-12">

                            <div class="form-group row"
                              *ngFor="let image of service_attach_uploaded().controls; let i=index">
                              <div class="col-sm-11">
                                <input type="hidden" class="form-control" formControlName="{{i}}">
                                <input type="hidden" class="filestyle" data-buttonText="Choose file"
                                  (change)="selectAttachment($event,i)" value="{{image.value.split('/').pop()}}">

                                <!-- <a (click)="imagePreview(image.value)">{{image.value.split('/').pop()}}</a> -->
                                <a href="http://vmi313621.contaboserver.net/Software_backend/uploads/problem_solving/{{image.value.split('/').pop()}}"
                                  target="_blank">{{image.value.split('/').pop()}}</a>

                              </div>
                              <div class="col-sm-1">
                                <button class="btn btn-primary pull-right" type="button"
                                  (click)="removeAttachmentUploaded(i)" [attr.disabled]="treatment_settings.butDis ? '' : null">
                                  <i class="fa fa-trash-o"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>



                        <input type="hidden" name="old_img[]" value="">
                        <p style="text-align:right;">{{ treatment_settings.last_modified  }}</p>          

                      </div>
                      <div class="panel-footer">

                        <!-- <button onclick="return ch_tre_emp();" type="submit" name="save_course" id="teatment_id"
                          class="btn btn-purple pull-right " style="background-color: #b607dc; color: white;">Save</button> -->

                        <button type="submit" id="treatment_submit" class="btn btn-success" style="float: right;" [style.display]="treatment_settings.save_t" [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">{{ lang.save }}</button>


                      <button type="button" class="btn btn-purple " [style.display]="treatment_settings.button1" id="treatment_un1"  (click)="treatment_unlock('1',this.treatment.id)" [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">{{ lang.unlock}}</button>
                                              <div class="clearfix"></div>
                      </div>
                    </form>
                  </div>


                </div>

                <div class="tab-pane in" [ngClass]="selectedTab == 'cause' ? 'active' : 'none'" id="cause_analysis">

                  <div class="panel panel-default" *ngIf="cause">
                    <form [formGroup]="causeForm" class="form-validation" (ngSubmit)="onCauseSubmit()">
                      <div class="panel-body ">
                        <div class="form-group col-sm-12">
                          <label class="col-sm-2 control-label" for="form-field-2">
                            <!-- Treatment Implemented --> {{ lang.causeanalysis }}
                          </label>
                          <div class="col-sm-10">
                            <textarea class="form-control" formControlName="treatment_cause"
                              [ngClass]="formErrorClass(causeForm.controls.treatment_cause, causeFormSubmitted)" [readonly]="cause_settings.readonly1"></textarea>

                              <ng-template [ngTemplateOutlet]="ErrorMsg"
                              [ngTemplateOutletContext]="{msg:causeFormErrorMsg.treatment_cause, value:causeForm.controls.treatment_cause, submitted:causeFormSubmitted }">
                            </ng-template>

                          </div>
                        </div>

                        <input type="hidden" name="cproblem_id" value="">
                        <input type="hidden"  name="cause_id" value="">


                        <div class="form-group col-sm-12">
                          <label class="col-sm-2 control-label" for="form-field-1">
                            <!-- Figures involved --> {{ lang.figuresInvolved }}
                          </label>

                          <div class="col-sm-10 bcb">

                            <input type="hidden" name="cempList" value="667" id="cempList">

                            <!-- <input type="hidden" name="ajaxValues" value="" id="ajaxValues"> -->


                            <div class="col-sm-6" formArrayName="causeEmpBlck1">
                              <label>{{ lang.internalReference }}</label>
                              <div class="form-group row"
                                *ngFor="let ceref of causeEmpBlck1().controls; let i=index">
                                <div class="col-sm-8">

                                  <select class="form-control"  formControlName="{{i}}"
                                  [ngClass]="formErrorClass(causeEmpBlck1().controls[i], causeFormSubmitted)"
                                    style="width: 140%;"  [attr.disabled]="cause_settings.butDis_cause ? '' : null">
                                    <option value="">{{ lang.selectEmployee }}</option>
                                    <option *ngFor="let type of emp_list" [ngValue]="type.item_id">{{type.item_name}}
                                    </option>
                                  </select>

                                  <ng-template [ngTemplateOutlet]="ErrorMsg"
                                  [ngTemplateOutletContext]="{msg:causeFormErrorMsg.causeEmpBlck1, value:causeForm.controls.causeEmpBlck1, submitted:causeFormSubmitted }">
                                </ng-template>


                                </div>
                                <div class="col-sm-4" style="padding: 0%;">
                                  <button class="btn btn-primary pull-right" type="button" (click)="caddEmployees()"
                                    *ngIf=" i==(causeEmpBlck1().controls.length-1) "  [attr.disabled]="cause_settings.butDis_cause ? '' : null">
                                    <i class="fa fa-plus"></i>
                                  </button>

                                  <button class="btn btn-primary pull-right" type="button" (click)="cremoveEmail1(i)"
                                    *ngIf=" i!=(causeEmpBlck1().controls.length-1) "  [attr.disabled]="cause_settings.butDis_cause ? '' : null">
                                    <i class="fa fa-trash-o"></i>
                                  </button>

                                </div>
                              </div>
                            </div> 

                            <div class="col-sm-6" formArrayName="cause_externalReferences">
                                <label>{{ lang.externalReference }}</label>
                                <div class="form-group row" *ngFor="let email of cause_externalReferences().controls; let i=index">
                                  <div class="col-sm-8">
                                    <input type="text" class="form-control" formControlName="{{i}}"
                                      [ngClass]="formErrorClass(cause_externalReferences().controls[i], causeFormSubmitted)"
                                      style="width: 140%;"   [attr.disabled]="cause_settings.butDis_cause ? '' : null">
                      
                                    <ng-template [ngTemplateOutlet]="ErrorMsg"
                                      [ngTemplateOutletContext]="{msg:causeFormErrorMsg.cause_externalReferences, value:cause_externalReferences().controls[i], submitted:causeFormSubmitted }">
                                    </ng-template>
                      
                                  </div>
                                  <div class="col-sm-4" style="padding: 0%;">
                                    <button class="btn btn-primary pull-right" type="button" (click)="cremoveEmail(i)"
                                      *ngIf=" i!=(cause_externalReferences().controls.length-1) "  [attr.disabled]="cause_settings.butDis_cause ? '' : null">
                                      <i class="fa fa-trash-o"></i>
                                    </button>
                                    <button class="btn btn-primary pull-right" type="button" (click)="caddEmail()"
                                      *ngIf=" i==(cause_externalReferences().controls.length-1) "  [attr.disabled]="cause_settings.butDis_cause ? '' : null">
                                      <i class="fa fa-plus"></i>
                                    </button>
                                  </div>
                                </div>
                            </div>


                          </div>
                        </div>


                        <div class="form-group col-sm-12">
                          <label class="col-sm-2 control-label" for="form-field-1">
                            <!-- Date --> {{ lang.date }}
                          </label>
                          <div class="col-sm-9">
                            <input type="date" class="form-control" formControlName="date_cause"
                              [ngClass]="formErrorClass(causeForm.controls.date_cause, causeFormSubmitted)" [readonly]="cause_settings.readonly1">

                              <ng-template [ngTemplateOutlet]="ErrorMsg"
                              [ngTemplateOutletContext]="{msg:causeFormErrorMsg.date_cause, value:causeForm.controls.date_cause, submitted:causeFormSubmitted }">
                            </ng-template>


                          </div>
                        </div><br><br><br><br><br><br><br>

                        <div class="form-group col-sm-12">
                          <label class="col-sm-2 control-label">{{ lang.cost }}</label>
                          <div class="col-sm-9">
                            <input type="text" class="form-control" formControlName="cost_cause"
                              [ngClass]="formErrorClass(causeForm.controls.cost_cause, causeFormSubmitted)" [readonly]="cause_settings.readonly1">

                              <ng-template [ngTemplateOutlet]="ErrorMsg"
                              [ngTemplateOutletContext]="{msg:causeFormErrorMsg.cost_cause, value:causeForm.controls.cost_cause, submitted:causeFormSubmitted }">
                            </ng-template>



                          </div>
                        </div>


                        <div class="col-sm-12" formArrayName="cause_attach_exists">
                          <div class="form-group col-sm-12">
                            <label>{{ lang.attachments }}</label>
                            <div class="form-group row"
                              *ngFor="let link of cause_attach_exists().controls; let i = index;" [formGroupName]="i">
                              <div class="col-sm-11">
                                <input type="file" class="filestyle" data-buttonText="Choose file"
                                  (change)="selectAttachment2($event,i)" formControlName="link" appFileDesign>


                              </div>
                              <div class="col-sm-1">
                                <button class="btn btn-primary pull-right" type="button" (click)="cremoveAttachment(i)"
                                  *ngIf=" i!=(cause_attach_exists().controls.length-1) "  [attr.disabled]="cause_settings.butDis_cause ? '' : null">
                                  <i class="fa fa-trash-o"></i>
                                </button>
                                <button class="btn btn-primary pull-right" type="button" (click)="caddAttachment()"
                                  *ngIf=" i==(cause_attach_exists().controls.length-1) "  [attr.disabled]="cause_settings.butDis_cause ? '' : null">
                                  <i class="fa fa-plus"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div> 


                       <div class="col-sm-12" formArrayName="cause_attach_uploaded">
                          <div class="form-group col-sm-12">

                            <div class="form-group row"
                              *ngFor="let image of cause_attach_uploaded().controls; let i=index">
                              <div class="col-sm-11">
                                <input type="hidden" class="form-control" formControlName="{{i}}">
                                <input type="hidden" class="filestyle" data-buttonText="Choose file"
                                  (change)="selectAttachment($event,i)" value="{{image.value.split('/').pop()}}">

                                <a href="http://vmi313621.contaboserver.net/Software_backend/uploads/problem_solving/{{image.value.split('/').pop()}}"
                                  target="_blank">{{image.value.split('/').pop()}}</a>

                              </div>
                              <div class="col-sm-1">
                                <button class="btn btn-primary pull-right" type="button"
                                  (click)="cremoveAttachmentUploaded(i)"  [attr.disabled]="cause_settings.butDis_cause ? '' : null">
                                  <i class="fa fa-trash-o"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>



                        <input type="hidden" name="old_img[]" value="">
                        <p style="text-align:right;">{{ cause_settings.last_modified  }}</p>          

                      </div>
                      <div class="panel-footer">

                        <!-- <button onclick="return ch_tre_emp();" type="submit" name="save_course" id="teatment_id"
                          class="btn btn-purple pull-right " style="background-color: #b607dc; color: white;">Save</button> -->

                        <!-- <button type="submit" class="btn btn-success" style="float: right;">Save</button>


                        <button type="button" class="btn btn-purple " style="display:none" id="teatment_un"
                          onclick="treatment_unlock('1','344');">Unlock</button>
                        <div class="clearfix"></div> -->

                        <button type="submit" id="cause_submit" class="btn btn-success" style="float: right;" [style.display]="cause_settings.save_t1" [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">{{ lang.save }}</button>


                        <button type="button" class="btn btn-purple " [style.display]="cause_settings.button2" id="treatment_un2"  (click)="treatment_unlock('2',this.cause.id)" [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">{{ lang.unlock }}</button>
                         <div class="clearfix"></div>


                      </div>
                    </form>
                  </div>


                </div>                

                <div class="tab-pane in" [ngClass]="selectedTab == 'corrective' ? 'active' : 'none'" id="corrective_actions">

                  <div class="panel panel-default" *ngIf="corrective">
                    <form [formGroup]="correctiveForm" class="form-validation" (ngSubmit)="onCorrectSubmit()">
                      <div class="panel-body ">
                        <div class="form-group col-sm-12">
                          <label class="col-sm-2 control-label" for="form-field-2">
                            <!-- Treatment Implemented --> {{ lang.correctionAction }}
                          </label>
                          <div class="col-sm-10">
                            <textarea class="form-control" formControlName="treatment_correct"
                              [ngClass]="formErrorClass(correctiveForm.controls.treatment_correct, correctiveFormSubmitted)"  [readonly]="corrective_settings.readonly2"></textarea>
 
                              <ng-template [ngTemplateOutlet]="ErrorMsg"
                              [ngTemplateOutletContext]="{msg:correctiveFormErrorMsg.treatment_correct, value:correctiveForm.controls.treatment_correct, submitted:correctiveFormSubmitted }">
                            </ng-template>

                          </div>
                        </div>

                        <input type="hidden" name="caproblem_id" value="">
                        <input type="hidden"  name="caause_id" value="">


                        <div class="form-group col-sm-12">
                          <label class="col-sm-2 control-label" for="form-field-1">
                            <!-- Figures involved --> {{ lang.figuresInvolved }}
                          </label>

                          <div class="col-sm-10 bcb">

                            <input type="hidden" name="caempList" value="" id="caempList">

                            <!-- <input type="hidden" name="ajaxValues" value="" id="ajaxValues"> -->


                            <div class="col-sm-6" formArrayName="correctiveEmpBlck1">
                              <label>{{ lang.internalReference }}</label>
                              <div class="form-group row"
                                *ngFor="let ceref of correctiveEmpBlck1().controls; let i=index">
                                <div class="col-sm-8">

                                  <select class="form-control"  formControlName="{{i}}"
                                  [ngClass]="formErrorClass(correctiveEmpBlck1().controls[i], correctiveFormSubmitted)"
                                    style="width: 140%;" [attr.disabled]="corrective_settings.butDis_corrective ? '' : null">
                                    <option value="">{{ lang.selectEmployee }}</option>
                                    <option *ngFor="let type of emp_list" [ngValue]="type.item_id">{{type.item_name}}
                                    </option>
                                  </select>

                                  <ng-template [ngTemplateOutlet]="ErrorMsg"
                                  [ngTemplateOutletContext]="{msg:correctiveFormErrorMsg.correctiveEmpBlck1, value:correctiveForm.controls.correctiveEmpBlck1, submitted:correctiveFormSubmitted }">
                                </ng-template>


                                </div>
                                <div class="col-sm-4" style="padding: 0%;">
                                  <button class="btn btn-primary pull-right" type="button" (click)="caaddEmployees()"
                                    *ngIf=" i==(correctiveEmpBlck1().controls.length-1) " [attr.disabled]="corrective_settings.butDis_corrective ? '' : null">
                                    <i class="fa fa-plus"></i>
                                  </button>

                                  <button class="btn btn-primary pull-right" type="button" (click)="caremoveEmail1(i)"
                                    *ngIf=" i!=(correctiveEmpBlck1().controls.length-1) " [attr.disabled]="corrective_settings.butDis_corrective ? '' : null">
                                    <i class="fa fa-trash-o"></i>
                                  </button>

                                </div>
                              </div>
                            </div> 

                            <div class="col-sm-6" formArrayName="corr_externalReferences">
                                <label>{{ lang.externalReference }}</label>
                                <div class="form-group row" *ngFor="let email of corr_externalReferences().controls; let i=index">
                                  <div class="col-sm-8">
                                    <input type="text" class="form-control" formControlName="{{i}}"
                                      [ngClass]="formErrorClass(corr_externalReferences().controls[i], correctiveFormSubmitted)"
                                      style="width: 140%;" [attr.disabled]="corrective_settings.butDis_corrective ? '' : null">
                      
                                    <ng-template [ngTemplateOutlet]="ErrorMsg"
                                      [ngTemplateOutletContext]="{msg:correctiveFormErrorMsg.corr_externalReferences, value:corr_externalReferences().controls[i], submitted:correctiveFormSubmitted }">
                                    </ng-template>
                      
                                  </div>
                                  <div class="col-sm-4" style="padding: 0%;">
                                    <button class="btn btn-primary pull-right" type="button" (click)="caremoveEmail(i)"
                                      *ngIf=" i!=(corr_externalReferences().controls.length-1) " [attr.disabled]="corrective_settings.butDis_corrective ? '' : null">
                                      <i class="fa fa-trash-o"></i>
                                    </button>
                                    <button class="btn btn-primary pull-right" type="button" (click)="caaddEmail()"
                                      *ngIf=" i==(corr_externalReferences().controls.length-1) " [attr.disabled]="corrective_settings.butDis_corrective ? '' : null">
                                      <i class="fa fa-plus"></i>
                                    </button>
                                  </div>
                                </div>
                            </div>


                          </div>
                        </div>


                        <div class="form-group col-sm-12">
                          <label class="col-sm-2 control-label" for="form-field-1">
                            <!-- Date --> {{ lang.date }}
                          </label>
                          <div class="col-sm-9">
                            <input type="date" class="form-control" formControlName="date_correct"
                              [ngClass]="formErrorClass(correctiveForm.controls.date_correct, correctiveFormSubmitted)"  [readonly]="corrective_settings.readonly2">

                              <ng-template [ngTemplateOutlet]="ErrorMsg"
                              [ngTemplateOutletContext]="{msg:causeFormErrorMsg.date_correct, value:correctiveForm.controls.date_correct, submitted:correctiveFormSubmitted }">
                            </ng-template>


                          </div>
                        </div><br><br><br><br><br><br><br>

                        <div class="form-group col-sm-12">
                          <label class="col-sm-2 control-label">{{ lang.cost }}</label>
                          <div class="col-sm-9">
                            <input type="text" class="form-control" formControlName="cost_correct"
                              [ngClass]="formErrorClass(correctiveForm.controls.cost_correct, correctiveFormSubmitted)" [readonly]="corrective_settings.readonly2">

                              <ng-template [ngTemplateOutlet]="ErrorMsg"
                              [ngTemplateOutletContext]="{msg:causeFormErrorMsg.cost_correct, value:correctiveForm.controls.cost_correct, submitted:correctiveFormSubmitted }">
                            </ng-template>



                          </div>
                        </div>


                        <div class="col-sm-12" formArrayName="corr_attach_exists">
                          <div class="form-group col-sm-12">
                            <label>{{ lang.attachments }}</label>
                            <div class="form-group row"
                              *ngFor="let link of corr_attach_exists().controls; let i = index;" [formGroupName]="i">
                              <div class="col-sm-11">
                                <input type="file" class="filestyle" data-buttonText="Choose file"
                                  (change)="selectAttachment3($event,i)" formControlName="link" [attr.disabled]="corrective_settings.butDis_corrective ? '' : null" appFileDesign>


                              </div>
                              <div class="col-sm-1">
                                <button class="btn btn-primary pull-right" type="button" (click)="caremoveAttachment(i)"
                                  *ngIf=" i!=(corr_attach_exists().controls.length-1) "  [attr.disabled]="corrective_settings.butDis_corrective ? '' : null">
                                  <i class="fa fa-trash-o"></i>
                                </button>
                                <button class="btn btn-primary pull-right" type="button" (click)="caaddAttachment()"
                                  *ngIf=" i==(corr_attach_exists().controls.length-1) " [attr.disabled]="corrective_settings.butDis_corrective ? '' : null">
                                  <i class="fa fa-plus"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div> 


                       <div class="col-sm-12" formArrayName="corr_attach_uploaded">
                          <div class="form-group col-sm-12">

                            <div class="form-group row"
                              *ngFor="let image of corr_attach_uploaded().controls; let i=index">
                              <div class="col-sm-11">
                                <input type="hidden" class="form-control" formControlName="{{i}}">
                                <input type="hidden" class="filestyle" data-buttonText="Choose file"
                                  (change)="selectAttachment($event,i)" value="{{image.value.split('/').pop()}}">

                                <a href="http://vmi313621.contaboserver.net/Software_backend/uploads/problem_solving/{{image.value.split('/').pop()}}"
                                  target="_blank">{{image.value.split('/').pop()}}</a>

                              </div>
                              <div class="col-sm-1">
                                <button class="btn btn-primary pull-right" type="button"
                                  (click)="caremoveAttachmentUploaded(i)"  [attr.disabled]="corrective_settings.butDis_corrective ? '' : null">
                                  <i class="fa fa-trash-o"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>



                        <input type="hidden" name="old_img[]" value="">
                        <p style="text-align:right;">{{ corrective_settings.last_modified  }}</p>          

                      </div>
                      <div class="panel-footer">

                        <!-- <button onclick="return ch_tre_emp();" type="submit" name="save_course" id="teatment_id"
                          class="btn btn-purple pull-right " style="background-color: #b607dc; color: white;">Save</button> -->

                        <!-- <button type="submit" class="btn btn-success" style="float: right;">Save</button>


                        <button type="button" class="btn btn-purple " style="display:none" id="teatment_un"
                          onclick="treatment_unlock('1','344');">Unlock</button>
                        <div class="clearfix"></div> -->

                        <button type="submit" id="corrective_submit" class="btn btn-success" style="float: right;" [style.display]="corrective_settings.save_t2" [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">{{ lang.save }}</button>


                        <button type="button" class="btn btn-purple " [style.display]="corrective_settings.button3" id="treatment_un3"  (click)="treatment_unlock('3',this.corrective.id)" [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">{{ lang.unlock }}</button>
                         <div class="clearfix"></div>


                      </div>
                    </form>
                  </div>


                </div>

                <div class="tab-pane in" [ngClass]="selectedTab == 'check' ? 'active' : 'none'" id="check_effectiveness">

                  <div class="panel panel-default" *ngIf="check">
                    <form [formGroup]="checkForm" class="form-validation" (ngSubmit)="onCheckSubmit()">
                      <div class="panel-body ">
                        <div class="form-group col-sm-12">
                          <label class="col-sm-2 control-label" for="form-field-2">
                            <!-- Treatment Implemented --> {{ lang.finalAnalysis }}
                          </label>
                          <div class="col-sm-10">
                            <textarea class="form-control" formControlName="treatment_check"
                              [ngClass]="formErrorClass(checkForm.controls.treatment_check, checkFormSubmitted)"  [readonly]="check_settings.readonly3"></textarea>

                              <ng-template [ngTemplateOutlet]="ErrorMsg"
                              [ngTemplateOutletContext]="{msg:correctiveFormErrorMsg.treatment_check, value:checkForm.controls.treatment_check, submitted:checkFormSubmitted }">
                            </ng-template>

                          </div>
                        </div>

                        <input type="hidden" name="ceproblem_id" value="">
                        <input type="hidden"  name="check_id" value="">


                        <div class="form-group col-sm-12">
                          <label class="col-sm-2 control-label" for="form-field-1">
                            <!-- Figures involved --> {{ lang.figuresInvolved }}
                          </label>

                          <div class="col-sm-10 bcb">

                            <input type="hidden" name="ceempList" value="" id="ceempList">

                            <!-- <input type="hidden" name="ajaxValues" value="" id="ajaxValues"> -->


                            <div class="col-sm-6" formArrayName="checkEmpBlck1">
                              <label>{{ lang.internalReference }}</label>
                              <div class="form-group row"
                                *ngFor="let ceref of checkEmpBlck1().controls; let i=index">
                                <div class="col-sm-8">

                                  <select class="form-control"  formControlName="{{i}}"
                                  [ngClass]="formErrorClass(checkEmpBlck1().controls[i], checkFormSubmitted)"
                                    style="width: 140%;"  [attr.disabled]="check_settings.butDis_check ? '' : null">
                                    <option value="">{{ lang.selectEmployee }}</option>
                                    <option *ngFor="let type of emp_list" [ngValue]="type.item_id">{{type.item_name}}
                                    </option>
                                  </select>

                                  <ng-template [ngTemplateOutlet]="ErrorMsg"
                                  [ngTemplateOutletContext]="{msg:correctiveFormErrorMsg.checkEmpBlck1, value:checkForm.controls.checkEmpBlck1, submitted:checkFormSubmitted }">
                                </ng-template>


                                </div>
                                <div class="col-sm-4" style="padding: 0%;">
                                  <button class="btn btn-primary pull-right" type="button" (click)="ceaddEmployees()"
                                    *ngIf=" i==(checkEmpBlck1().controls.length-1) " [attr.disabled]="check_settings.butDis_check ? '' : null">
                                    <i class="fa fa-plus"></i>
                                  </button>

                                  <button class="btn btn-primary pull-right" type="button" (click)="ceremoveEmail1(i)"
                                    *ngIf=" i!=(checkEmpBlck1().controls.length-1) " [attr.disabled]="check_settings.butDis_check ? '' : null">
                                    <i class="fa fa-trash-o"></i>
                                  </button>

                                </div>
                              </div>
                            </div> 

                            <div class="col-sm-6" formArrayName="check_externalReferences">
                                <label>{{ lang.externalReference }}</label>
                                <div class="form-group row" *ngFor="let email of check_externalReferences().controls; let i=index">
                                  <div class="col-sm-8">
                                    <input type="text" class="form-control" formControlName="{{i}}"
                                      [ngClass]="formErrorClass(check_externalReferences().controls[i], checkFormSubmitted)"
                                      style="width: 140%;" [attr.disabled]="check_settings.butDis_check ? '' : null">
                      
                                    <ng-template [ngTemplateOutlet]="ErrorMsg"
                                      [ngTemplateOutletContext]="{msg:correctiveFormErrorMsg.check_externalReferences, value:check_externalReferences().controls[i], submitted:checkFormSubmitted }">
                                    </ng-template>
                      
                                  </div>
                                  <div class="col-sm-4" style="padding: 0%;">
                                    <button class="btn btn-primary pull-right" type="button" (click)="ceremoveEmail(i)"
                                      *ngIf=" i!=(check_externalReferences().controls.length-1) " [attr.disabled]="check_settings.butDis_check ? '' : null">
                                      <i class="fa fa-trash-o"></i>
                                    </button>
                                    <button class="btn btn-primary pull-right" type="button" (click)="ceaddEmail()"
                                      *ngIf=" i==(check_externalReferences().controls.length-1) " [attr.disabled]="check_settings.butDis_check ? '' : null">
                                      <i class="fa fa-plus"></i>
                                    </button>
                                  </div>
                                </div>
                            </div>


                          </div>
                        </div>


                        <div class="form-group col-sm-12">
                          <label class="col-sm-2 control-label" for="form-field-1">
                            <!-- Date --> {{ lang.date }}
                          </label>
                          <div class="col-sm-9">
                            <input type="date" class="form-control" formControlName="date_check"
                              [ngClass]="formErrorClass(checkForm.controls.date_check, checkFormSubmitted)" [readonly]="check_settings.readonly3">

                              <ng-template [ngTemplateOutlet]="ErrorMsg"
                              [ngTemplateOutletContext]="{msg:checkFormErrorMsg.date_correct, value:checkForm.controls.date_check, submitted:checkFormSubmitted }">
                            </ng-template>


                          </div>
                        </div><br><br><br><br><br><br><br>

                        <div class="form-group col-sm-12">
                          <label class="col-sm-2 control-label">{{ lang.cost }}</label>
                          <div class="col-sm-9">
                            <input type="text" class="form-control" formControlName="cost_check"
                              [ngClass]="formErrorClass(checkForm.controls.cost_check, checkFormSubmitted)" [readonly]="check_settings.readonly3">

                              <ng-template [ngTemplateOutlet]="ErrorMsg"
                              [ngTemplateOutletContext]="{msg:checkFormErrorMsg.cost_check, value:checkForm.controls.cost_check, submitted:checkFormSubmitted }">
                            </ng-template>



                          </div>
                        </div>


                        <div class="col-sm-12" formArrayName="check_attach_exists">
                          <div class="form-group col-sm-12">
                            <label>{{ lang.attachments }}</label>
                            <div class="form-group row"
                              *ngFor="let link of check_attach_exists().controls; let i = index;" [formGroupName]="i">
                              <div class="col-sm-11">
                                <input type="file" class="filestyle" data-buttonText="Choose file"
                                  (change)="selectAttachment4($event,i)" formControlName="link" [attr.disabled]="check_settings.butDis_check ? '' : null" appFileDesign>


                              </div>
                              <div class="col-sm-1">
                                <button class="btn btn-primary pull-right" type="button" (click)="ceremoveAttachment(i)"
                                  *ngIf=" i!=(check_attach_exists().controls.length-1) " [attr.disabled]="check_settings.butDis_check ? '' : null">
                                  <i class="fa fa-trash-o"></i>
                                </button>
                                <button class="btn btn-primary pull-right" type="button" (click)="ceaddAttachment()"
                                  *ngIf=" i==(check_attach_exists().controls.length-1) " [attr.disabled]="check_settings.butDis_check ? '' : null">
                                  <i class="fa fa-plus"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div> 


                       <div class="col-sm-12" formArrayName="check_attach_uploaded">
                          <div class="form-group col-sm-12">

                            <div class="form-group row"
                              *ngFor="let image of check_attach_uploaded().controls; let i=index">
                              <div class="col-sm-11">
                                <input type="hidden" class="form-control" formControlName="{{i}}">
                                <input type="hidden" class="filestyle" data-buttonText="Choose file"
                                  (change)="selectAttachment($event,i)" value="{{image.value.split('/').pop()}}" >

                                <a href="http://vmi313621.contaboserver.net/Software_backend/uploads/problem_solving/{{image.value.split('/').pop()}}"
                                  target="_blank">{{image.value.split('/').pop()}}</a>

                              </div>
                              <div class="col-sm-1">
                                <button class="btn btn-primary pull-right" type="button"
                                  (click)="ceremoveAttachmentUploaded(i)" [attr.disabled]="check_settings.butDis_check ? '' : null">
                                  <i class="fa fa-trash-o"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>



                        <input type="hidden" name="old_img[]" value="">
                        <p style="text-align:right;">{{ check_settings.last_modified  }}</p>          

                      </div>
                      <div class="panel-footer">

                        <!-- <button onclick="return ch_tre_emp();" type="submit" name="save_course" id="teatment_id"
                          class="btn btn-purple pull-right " style="background-color: #b607dc; color: white;">Save</button> -->

                        <!-- <button type="submit" class="btn btn-success" style="float: right;">Save</button>
                        <button type="button" class="btn btn-purple " style="display:none" id="teatment_un"
                          onclick="treatment_unlock('1','344');">Unlock</button>
                        <div class="clearfix"></div> -->

                        <button type="submit" id="check_submit" class="btn btn-success" style="float: right;" [style.display]="check_settings.save_t3" [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">{{ lang.save }}</button>


                        <button type="button" class="btn btn-purple " [style.display]="check_settings.button4" id="treatment_un4"  (click)="treatment_unlock('4',this.check.id)" [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">{{ lang.unlock }}</button>
                         <div class="clearfix"></div>




                      </div>
                    </form>
                  </div>


                </div>

                <div class="tab-pane in" id="report">
                  <div class="tab-pane" id="panel_tab3_example6" style="width: 100%;">
                    <div class="panel panel-default newpadbott panel-data08">

                      <div class="panel-footer">

                        <a class="btn btn-primary" id="generate_pd" style="float: right;background: #00a54f;" (click)="convetToPDF(this.id)">{{ lang.generatePdf }}
                        </a>
                        <button type="button" style="float:right; margin-right: 5px; background: #0095d9; color: white;"
                          class="btn btn-skybluenew" id="" data-toggle="modal" data-target="#sendcustomer" (click)="sendStake()" [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'" sss>{{ lang.sendStakeholders }}</button>


                        <div class="clearfix"></div>
                      </div>
                      <div class="col-sm-12 ">
                        <div class="panel-body" style="min-height:300px;">
                          <div class="table-responsive">
                            <div class="table-responsive">
                              <!-- <table class="table table-striped table-hover"> -->
                              <table datatable class="table-striped table-sm row-border hover" id="table1"
                                *ngIf="get_action_data">
                                <thead>
                                  <tr>

                                    <th> No. </th>
                                    <th> {{ lang.dateofsent }} </th>
                                    <th> {{ lang.sender }} </th>
                                    <th> {{ lang.recipients }} </th>
                                    <th> {{ lang.subject }} </th>
                                    <th> {{ lang.distributionStaus }} </th>
                                    <th> {{ lang.attachments }} </th>
                                    <th> {{ lang.action }} </th>

                                  </tr>
                                </thead>
                                <tr *ngFor="let record of get_action_data let i = index" id="{{record.id}}">
                                  <td>{{i+1}}</td>
                                  <td>{{record.sent_date }}</td>
                                  <td>{{record.sender }}</td>
                                  <td>{{record.recipient }}</td>
                                  <td>{{record.subject }}</td>
                                  <td>
                                    <div [innerHTML]="record.actstat"></div>
                                  </td>
                                  <td><a href="{{record.attval }}">{{record.katt }}</a></td>
                                  <td>
                                    <div class="btn-group dropup">

                                      <button type="button" class="btn btn-info dropdown-toggle circle_btn"
                                        data-toggle="dropdown" aria-expanded="false"><i
                                          class="fa fa-tasks"></i></button>

                                      <ul class="dropdown-menu dropdown-menu-right action_btn" role="menu">
                                        <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a
                                            class="blue_action" (click)="delete(record.id)"><i class="fa fa-trash"></i>
                                            {{ lang.delete }}</a></li>
                                        <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a
                                            class="blue_action" (click)="mail(record.id)"><i class="fa fa-trash"></i>
                                            {{ lang.mail }}</a></li>
                                      </ul>
                                    </div>
                                  </td>

                                </tr>
                                <tbody>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>


                    </div>
                  </div>
                </div>


              </div>

            </div>
          </div>

          <!-- </div>

                  </div>


                </div>
              </div>
            </div>

          </div> -->



        </div>
      </div>

    </div>
  </div>
</section>

<div class="modal splash fade" id="sactivate_plan" tabindex="-1" role="dialog" aria-hidden="true">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">{{ lang?.enterStartdate }}</h3>
      </div>

      <form #user="ngForm" (ngSubmit)="onSubmit(user.value)">
        <div class="modal-body column_export">
          <input type="date" class="form-control" name="date" id="date" value="" ngModel required>
          <input type="hidden" name="plan_id_forcd" id="plan_id_forcd" ngModel>
          <input type="hidden" name="pservice_id" id="pservice_id" ngModel>
        </div>

        <div class="modal-footer">
          <div id="datatableExportBtn1" class="export_dynamic_btn">
          </div>
          <button class="btn btn-success">{{ lang?.submit }}</button>
          <button class="btn btn-warning" data-dismiss="modal">{{ lang?.close }}</button>
        </div>
      </form>

    </div>
  </div>
</div>

<div class="modal splash fade" id="datatableExport2" tabindex="-1" role="dialog" aria-hidden="true">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">Select Columns</h3>
      </div>

      <div class="modal-body column_export">
        <div class="row select-alls">
          <label class="checkbox checkbox-custom-alt checkbox-custom-sm"> <input type="checkbox"
              (change)="export2_select_deselect_all($event)"><i></i> Select All </label>
        </div>
        <div class="row flexs">

          <div class="active-left">
            <h2>Active Columns</h2>

            <div class="row" *ngFor="let option of datatableCols2">
              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                  (change)="export2_select_deselect($event)"><i></i> {{option.value}}
              </label>
            </div>

          </div>

        </div>

      </div>

      <div class="modal-footer">
        <div id="datatableExportBtn2" class="export_dynamic_btn">
        </div>
        <button class="btn btn-warning" data-dismiss="modal">Close</button>
      </div>

    </div>
  </div>
</div>

<div class="modal splash fade" id="odatatableExport3" tabindex="-1" role="dialog" aria-hidden="true"
  style="display: none;">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">{{ odlang?.selectColumns }}</h3>
      </div>

      <div class="modal-body column_export">
        <input type="hidden" name="scol_val" class="scol_val" value="">
        <div class="row select-alls">
          <label class="checkbox checkbox-custom-alt checkbox-custom-sm"> <input type="checkbox"
              (change)="export3_select_deselect_all($event)"><i></i> {{ odlang?.selectAll }} </label>
        </div>
        <div class="row flexs">

          <div class="active-left">
            <h2>{{ odlang?.activeColumns }}</h2>

            <div class="row" *ngFor="let option of datatableCols3">
              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                  (change)="export3_select_deselect($event)"><i></i> {{option.value}}
              </label>
            </div>

          </div>

        </div>

      </div>

      <div class="modal-footer">
        <div id="datatableExportBtn3" class="export_dynamic_btn">
        </div>
        <button class="btn btn-warning" data-dismiss="modal">{{ odlang?.close }}</button>
      </div>

    </div>
  </div>
</div>

<div class="modal splash fade" id="datatableExport4" tabindex="-1" role="dialog" aria-hidden="true">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">{{ doclang?.selectColumns }}</h3>
      </div>

      <div class="modal-body column_export">
        <div class="row select-alls">
          <label class="checkbox checkbox-custom-alt checkbox-custom-sm"> <input type="checkbox"
              (change)="export4_select_deselect_all($event)"><i></i> {{ doclang?.selectAll }} </label>
        </div>
        <div class="row flexs">

          <div class="active-left">
            <h2>{{ doclang?.activeColumns }}</h2>

            <div class="row" *ngFor="let option of datatableCols4">
              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                  (change)="export3_select_deselect($event)"><i></i> {{option.value}}
              </label>
            </div>

          </div>

        </div>

      </div>

      <div class="modal-footer">
        <div id="datatableExportBtn4" class="export_dynamic_btn">
        </div>
        <button class="btn btn-warning" data-dismiss="modal">{{ doclang?.close }}</button>
      </div>

    </div>
  </div>
</div>
<div class="modal splash fade" id="datatableImport4" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">

      <!-- <div class="modal-header">
          <h3 class="modal-title custom-font">IMPORT HOURLY DATA</h3>
          <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
            <span aria-hidden="true">&times;</span>
          </button>      
        </div>
         -->

      <div class="modal-header">
        <h4 class="modal-title pull-left">{{ doclang?.dataImport }}</h4>
        <button type="button" class="close pull-right" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>


      <div class="modal-body column_export">
        <div class="row">
          <form>
            <input type="file" class="filestyle" id="file" name='file' data-buttonText="Choose file"
              (change)="onPhotoPickerChange($event)">
            <font style="vertical-align: inherit;">
              <font style="vertical-align: inherit;"><a
                  href="http://vmi313621.contaboserver.net/Software_backend/uploads/documents.csv">{{
                  doclang?.downloadthecsvtemplate }}</a></font>
            </font>
          </form>
        </div>
      </div>

      <div class="modal-footer">
        <!-- <div id="datatableExportBtn2" class="export_dynamic_btn">
          </div> -->
        <button type="button" class="btn btn-primary" (click)="onclick()">{{ lang?.save }}</button>
        <!-- <button class="btn btn-warning" data-dismiss="modal">Close</button>-->
        <button type="button" class="btn btn-warning" data-dismiss="modal">{{ doclang?.close }}</button>

      </div>
    </div>
  </div>
</div>